module.exports = __webpack_public_path__ + "static/testimonial2-a8bc5fe6c3c633fad27c3e3b7910778d.jpg";